import React from "react";
import { Box, Grid } from "@mui/material";
import { useIntl } from "react-intl";

import { style } from "./style";

import defaultProfilePic from "@/assets/patient.png";

import { InputField } from "@/components/InputField";

import { useAppSelector } from "@/store/hooks";
import { ipDashboardDetails } from "@/store/slices/doctor/ipDashboard";

const TeamDetail: React.FC = () => {
  const intl = useIntl();

  const { viewHospitalTeamDetail } = useAppSelector(ipDashboardDetails);

  const teamDetail = [
    {
      id: "mobileNumberText",
      label: "Mobile Number",
      value: viewHospitalTeamDetail?.phoneNumber,
    },
    {
      id: "mobileNumberText",
      label: "Name",
      value: viewHospitalTeamDetail?.name,
    },
    {
      id: "mobileNumberText",
      label: "Role",
      value: viewHospitalTeamDetail?.role ?? "No Role",
    },
  ];

  return (
    <Grid item sx={style.container}>
      <Grid item sx={style.avatarContainer}>
        <Box
          component="img"
          src={viewHospitalTeamDetail?.profileUrl || ""}
          alt={viewHospitalTeamDetail?.name}
          sx={style.avatar}
          onError={(e) => (e.currentTarget.src = defaultProfilePic)}
        />
      </Grid>

      {teamDetail.map((team, index) => (
        <Grid item>
          <InputField
            value={team?.value}
            label={intl.formatMessage({
              id: team?.id,
              defaultMessage: team?.label,
            })}
            variant="outlined"
            placeholder={intl.formatMessage({
              id: team?.id,
              defaultMessage: team?.label,
            })}
            fullWidth
            disabled
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default TeamDetail;
